import { render, staticRenderFns } from "./zones.vue?vue&type=template&id=5967d282"
import script from "./zones.vue?vue&type=script&lang=js"
export * from "./zones.vue?vue&type=script&lang=js"
import style0 from "./zones.vue?vue&type=style&index=0&id=5967d282&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports